<template>
    <div class="game-layer full-layer">
        游戏开始
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">

</style>

<script>
    //script        
    import Tools from './../scripts/tools'
    import {gsap} from "gsap";
    //Global
    import Global from './../scripts/Global'

    export default {
        name: 'Game',
        data() {
            return {
                //游戏数值

                //游戏状态

                //游戏变量
            }
        },
        components: {},
        created() {

        },
        computed: {},
        methods: {}
    }
</script>